import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "total", "submitBtn"];

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => (cb.checked = checked));
    this.updateTotal();
  }

  updateTotal() {
    let total = 0;
    let anyChecked = false;

    this.checkboxTargets.forEach((cb) => {
      if (cb.checked) {
        total += parseInt(cb.dataset.amount, 10) || 0;
        anyChecked = true;
      }
    });

    this.totalTarget.textContent = `$${(total / 100).toFixed(2)}`;
    this.submitBtnTarget.disabled = !anyChecked;

    // Update select all state
    const allChecked =
      this.checkboxTargets.length > 0 &&
      this.checkboxTargets.every((cb) => cb.checked);
    this.selectAllTarget.checked = allChecked;
  }

  confirmSubmit(event) {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;
    const total = this.totalTarget.textContent;

    if (
      !confirm(
        `Are you sure you want to refund ${checkedCount} line item(s) totaling ${total}?`,
      )
    ) {
      event.preventDefault();
    }
  }
}
